import { inject, Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import type { Observable } from 'rxjs';
import { map, tap } from 'rxjs';

import { NotificationsService } from '@app/core/notification-service';
import { GamesState } from '@app/core/state/games-store';

@Injectable({
  providedIn: 'root',
})
export class AutoGameActivateChildGuard {
  readonly #notificationsService = inject(NotificationsService);
  readonly #store = inject(Store);

  readonly autoBetIsOn$: Observable<boolean> = this.#store.select(GamesState.autoBetIsOn);

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.autoBetIsOn$.pipe(
      tap((value) => {
        if (value) {
          this.#notificationsService.addInfoNotification('You need to stop auto betting first.');
        }
      }),
      map((value) => !value),
    );
  }
}
